// extracted by mini-css-extract-plugin
export default {"rootContainer":"K3YSs","titleContainer":"AzADo","title":"MiVRd","subtitle":"pu2HN","description":"DSRU-","linksContainer":"h1YdN","webview":"_9jOuo","skeleton-progress":"ZqLLH"};